import angular from 'angular';
import logger from '../../../shared/logger';

export const customLoader = (
    $q,
    EnvSettings,
    $rootScope,
    $timeout,
    $http,
    $localStorage,
    RouteService,
) => function () {
    const deferred = $q.defer();
    let language = RouteService.getUserPreference('uiLanguage');
    if (!language) {
        language = 'en-US';
    }
    RouteService.getUILanguage(language)
        .then((response) => {
            $localStorage.UILanguage = response.result.data;
            $localStorage.tokenSetForTranslation = false;

            deferred.resolve(response.result.data);

            $timeout(() => $rootScope.$broadcast('TRANSLATIONS_LOADED'));
        }, (err) => {
            logger.error(err);
            deferred.resolve({});
        });

    return deferred.promise;
};

angular
    .module('TALENYA-FE')
    .factory('customLoader', customLoader);
